var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIconMobi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0820312 14.5895C0.0820312 14.9213 0.350156 15.1895 0.682031 15.1895H14.482C14.8139 15.1895 15.082 14.9213 15.082 14.5895V6.71445H0.0820312V14.5895ZM14.482 1.53945H11.332V0.339453C11.332 0.256953 11.2645 0.189453 11.182 0.189453H10.132C10.0495 0.189453 9.98203 0.256953 9.98203 0.339453V1.53945H5.18203V0.339453C5.18203 0.256953 5.11453 0.189453 5.03203 0.189453H3.98203C3.89953 0.189453 3.83203 0.256953 3.83203 0.339453V1.53945H0.682031C0.350156 1.53945 0.0820312 1.80758 0.0820312 2.13945V5.43945H15.082V2.13945C15.082 1.80758 14.8139 1.53945 14.482 1.53945Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconMobi);
export default __webpack_public_path__ + "static/media/calendar-icon-mobi.5b3fa0c9f6043314f8ddd286ded0862c.svg";
export { ForwardRef as ReactComponent };